import styles from './ErrorPageRouter.module.scss';
import ErrorPage from '@cas/components/error-page/ErrorPage';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Footer from '@cas/components/footer/Footer';

export default function ErrorPageRouter() {
  const { t } = useTranslation();
  const error = useRouteError();

  let errorMessage: string;
  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.data?.message || error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    console.error(error);
    errorMessage = 'Unknown error';
  }

  return (
    <div className={styles.errorPageRoot}>
      <ErrorPage
        title={t('Oops')}
        message={t('UnexpectedErrorOccurred')}
        details={t(errorMessage)}
        isRootErrorPage
      />
      <Footer />
    </div>
  );
}
